import React, { useState, useEffect } from "react";
import Orders from "../../components/Store/DashboardTabs/Orders";
import StoreEditor from "../../components/Store/StoreEditor";
import StoreSidebarToggle from "../../components/Store/StoreSidebarToggle";
import { useDispatch, useSelector } from "react-redux";
import { setOrderById } from "../../redux/Reducer/Order/OrderSlice";
import { useNavigate, useLocation } from "react-router-dom";

function StoreDashboard() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const orderById = useSelector((state) => state?.order?.orderById);
  const activeForm = useSelector((state) => state?.formSwitcher?.activeForm);
  const [showEditor, setShowEditor] = useState(
    orderById && Object.keys(orderById).length > 0
  );

  const fromRecords = location?.state?.from === "records";

  useEffect(() => {
    if (orderById && Object.keys(orderById).length > 0) {
      setShowEditor(true);
    }
  }, [orderById]);

  return (
    <main>
      {showEditor ? (
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between gap-4 bg-white p-2.5 rounded-[22px] shadow-sm border border-primary-100 mb-2 sticky top-0 z-[100] backdrop-blur-md bg-white/90">
            <div className="flex items-center gap-3">
              <StoreSidebarToggle className="!p-2 bg-primary-50 hover:bg-primary-100 text-primary-700 rounded-xl" />
              <h1 className="text-[16px] font-bold text-primary-900 tracking-tight uppercase px-2 flex items-center gap-2">
                <span>Store Editor</span>
                {activeForm === "Edit" && orderById?.OID && (
                  <>
                    <span className="text-primary-300 font-light">|</span>
                    <span className="text-primary-600 lowercase font-medium">Order being edited:</span>
                    <span className="bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-[14px] font-bold border border-primary-100">{orderById.OID}</span>
                  </>
                )}
              </h1>
            </div>
            <button
              onClick={() => {
                dispatch(setOrderById({}));
                if (fromRecords) {
                  navigate("/store-records");
                } else {
                  setShowEditor(false);
                }
              }}
              className="flex items-center gap-2 px-5 py-2 bg-gray-100 text-gray-700 rounded-[15px] font-bold text-[12px] hover:bg-gray-200 transition-all active:scale-95 shadow-sm"
            >
              {fromRecords ? "Back to Records" : "Back to Orders"}
            </button>
          </div>
          <StoreEditor onClose={() => {
            dispatch(setOrderById({}));
            if (fromRecords) {
              navigate("/store-records");
            } else {
              setShowEditor(false);
            }
          }} />
        </div>
      ) : (
        <Orders onToggleEditor={() => setShowEditor(true)} />
      )}
    </main>
  );
}

export default StoreDashboard;
